// extracted by mini-css-extract-plugin
export default {"page":"FZ-z","cartModal":"GZ-z","checkout":"HZ-z","placeholder":"IZ-z","account":"JZ-z"};